import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CockpitCoreModule } from '@scientificnet/cockpit-core';
import { providersConfig } from './../config/authentication.config';
import { navigation } from './../config/navigation.config';
import { layout } from './../config/layout.config';
import { environment } from './../environments/environment';
import { translations } from './../locale/translations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    CockpitCoreModule.forRoot({
      environment,
      authentication: providersConfig,
      navigation,
      translations,
      layout,
    }),
  ],
  providers: [
    // here your services.
    // But using the "Tree-shaking" would be the best option!
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
